import React from 'react'
import AboutUsPage from '../../components/AboutUs/AboutUsPage'

const AboutUs = () => {
  return (
    <AboutUsPage/>
  )
}

export default AboutUs